import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { SiteProvider } from './context/SiteContext'
import { AuthProvider } from './context/AuthContext'
import { CartProvider } from './context/CartContext'
import AuthModal   from './components/layout/AuthModal'
import CartDrawer  from './components/layout/CartDrawer'
import Layout      from './components/layout/Layout'
import Home        from './pages/Home'
import Packages    from './pages/Packages'
import Services    from './pages/Services'
import Gallery     from './pages/Gallery'
import About       from './pages/About'
import Contact     from './pages/Contact'
import Shop           from './pages/Shop'
import ProductDetail  from './pages/ProductDetail'
import Checkout    from './pages/Checkout'
import DynamicPage from './pages/DynamicPage'
import DynamicPost from './pages/DynamicPost'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <SiteProvider>
        <AuthProvider>
          <CartProvider>
            <Router>
              <AuthModal />
              <CartDrawer />
              <Routes>
                <Route element={<Layout />}>
                  <Route index         element={<Home />} />
                  <Route path="packages"  element={<Packages />} />
                  <Route path="services"  element={<Services />} />
                  <Route path="gallery"   element={<Gallery />} />
                  <Route path="about"     element={<About />} />
                  <Route path="contact"   element={<Contact />} />
                  <Route path="shop"      element={<Shop />} />
                  <Route path="shop/:id"  element={<ProductDetail />} />
                  <Route path="checkout"  element={<Checkout />} />
                  <Route path="blog/:slug"  element={<DynamicPost />} />
                  <Route path=":slug"       element={<DynamicPage />} />
                </Route>
              </Routes>
            </Router>
          </CartProvider>
        </AuthProvider>
      </SiteProvider>
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )
}
